
export function trackPageView(pageUrl) {
  window.setTimeout(() => {
    if (window.ga && typeof window.ga.getAll === 'function') {
      const trackers = window.ga.getAll();

      if (Array.isArray(trackers) && trackers.length > 0) {
        const tracker = trackers[0];

        // Send tracking information for google analytics
        if (tracker && tracker.set && tracker.send) {
          tracker.set('page', pageUrl);
          tracker.send('pageview');
        }
      }
    }
  }, 0);
}

export {default as ImageCrop} from 'modules/ImageCrop/ImageCrop';
export {default as PdfSizes} from 'modules/PdfSizes';
export {default as ImageresizeApi} from 'modules/ImageresizeApi/ImageresizeApi';
export {default as Raven} from 'modules/raven';



// WEBPACK FOOTER //
// ./src/modules/index.js